import { Action } from 'common/interfaces/root';
import { publishersSettingsActionTypes as T } from '../actions';

const initState: AffiliateReportModule.AffiliateReportHistoryState = {
  loading: true,
  error: null,
  data: [],
};

export default (
  state: AffiliateReportModule.AffiliateReportHistoryState = initState,
  { type, payload }: Action
): AffiliateReportModule.AffiliateReportHistoryState => {
  switch (type) {
    case T.GET_AFFILIATE_REPORT_HISTORY:
      return { ...state, loading: true };

    case T.GET_AFFILIATE_REPORT_HISTORY_SUCCESS:
      return { ...state, loading: false, data: payload };

    case T.GET_AFFILIATE_REPORT_HISTORY_ERROR:
      return { ...state, loading: false, error: payload };

    default:
      return state;
  }
};
